import './tabs-menu.scss'

import { PropType } from 'vue';
import Component from 'vue-class-component';

import { ReactiveVue } from '@skinsoft/reactive-vue';

export const SELECTED_TAB_CHANGE_EVENT = 'selected-item-changed'

export interface TabsMenuEntry {
    title: string
    dataCy?: string
}

@Component({
    props: {
        selectedIndex: {
            type: Number,
        },
        entries: {
            type: Array as PropType<TabsMenuEntry[]>,
        },
    },
    template: require('./tabs-menu.html')
})
export class TabsMenu extends ReactiveVue {
    private entries: TabsMenuEntry[]
    private selectedIndex: number

    private isSelected(index: number) {
        return index === this.selectedIndex
    }

    private onTabClicked(index: number) {
        if(index !== this.selectedIndex) {
            this.$emit(SELECTED_TAB_CHANGE_EVENT, index)
        }
    }
}